import chalk from 'chalk'
import { readFileSync } from 'node:fs'
import { join, dirname } from 'node:path'
import { fileURLToPath } from 'node:url'

const __dirname = dirname(fileURLToPath(import.meta.url))

function readVersion(): string {
  try {
    // When installed globally: package.json is next to dist/
    let pkgPath = join(__dirname, 'package.json')
    let raw: string
    try {
      raw = readFileSync(pkgPath, 'utf-8')
    } catch {
      // In monorepo dev: dist/ is one level deep, package.json is at parent
      pkgPath = join(__dirname, '..', 'package.json')
      raw = readFileSync(pkgPath, 'utf-8')
    }
    const pkg = JSON.parse(raw)
    return pkg.version || '0.0.0'
  } catch {
    return '0.0.0'
  }
}

const VERSION = readVersion()
const W = 58

export function getVersion(): string {
  return VERSION
}

function tontyAscii(): string[] {
  return [
    '▄▄▄▄▄▄▄ ▄▄▄▄▄▄▄ ▄▄   ▄▄ ▄▄▄▄▄▄▄ ▄▄   ▄▄',
    '  ██    ██   ██ ███  ██   ██    ██   ██',
    '  ██    ██   ██ ██ █ ██   ██     █████ ',
    '  ██    ██   ██ ██  ███   ██       ██  ',
    '  ██     ▀▄▄▄▀  ██   ██   ██       ██  ',
  ]
}

const ANSI_SGR = new RegExp(`${String.fromCharCode(27)}\\[[0-9;]*m`, 'g')

function center(line: string, width: number): string {
  const visible = line.replace(ANSI_SGR, '')
  const pad = Math.max(0, Math.floor((width - visible.length) / 2))
  const padded = ' '.repeat(pad) + line
  const paddedVisible = padded.replace(ANSI_SGR, '')
  const rightPad = Math.max(0, width - paddedVisible.length)
  return padded + ' '.repeat(rightPad)
}

export function showWelcome(): void {
  console.log()
  console.log(
    chalk.gray('┌─[ ') + chalk.white.bold('tonty') + chalk.gray(' ]─' + '─'.repeat(W - 13) + '┐'),
  )
  console.log(chalk.gray('│') + ' '.repeat(W) + chalk.gray('│'))

  for (const line of tontyAscii()) {
    console.log(chalk.gray('│') + center(chalk.cyan.bold(line), W) + chalk.gray('│'))
  }

  console.log(chalk.gray('│') + ' '.repeat(W) + chalk.gray('│'))

  console.log(chalk.gray('│') + center(chalk.white.bold('TECH INTERVIEWS'), W) + chalk.gray('│'))
  console.log(chalk.gray('│') + center(chalk.gray('Évaluations Techniques'), W) + chalk.gray('│'))
  console.log(chalk.gray('│') + ' '.repeat(W) + chalk.gray('│'))
  console.log(chalk.gray('│') + center(chalk.gray('$ whoami'), W) + chalk.gray('│'))
  console.log(
    chalk.gray('│') +
      center(chalk.dim('Built by Members of Technical Staff @ Tonty'), W) +
      chalk.gray('│'),
  )
  console.log(chalk.gray('│') + ' '.repeat(W) + chalk.gray('│'))
  console.log(
    chalk.gray('│') + center(chalk.dim(`v${VERSION}  •  https://tonty.app`), W) + chalk.gray('│'),
  )
  console.log(chalk.gray('└' + '─'.repeat(W) + '┘'))
  console.log()
}

export function showScenarioInfo(
  name: string,
  description: string,
  difficulty: string,
  estimatedTime: string,
): void {
  const diffColor =
    difficulty === 'hard' ? chalk.red : difficulty === 'medium' ? chalk.yellow : chalk.green

  console.log(chalk.bold('  Scenario: ') + chalk.white(name))
  console.log(chalk.gray('  ' + description))
  console.log(
    chalk.gray('  Difficulty: ') +
      diffColor(difficulty) +
      chalk.gray('  Estimated: ') +
      chalk.white(estimatedTime),
  )
  console.log()
}

export function showSessionCode(code: string): void {
  console.log()
  console.log(
    chalk.gray('┌─[ ') + chalk.white.bold('session') + chalk.gray(' ]─' + '─'.repeat(W - 15) + '┐'),
  )
  console.log(chalk.gray('│') + ' '.repeat(W) + chalk.gray('│'))
  const codeLine = chalk.white.bold(`   Code: ${code}`)
  console.log(chalk.gray('│') + center(codeLine, W) + chalk.gray('│'))
  console.log(chalk.gray('│') + ' '.repeat(W) + chalk.gray('│'))
  console.log(chalk.gray('└' + '─'.repeat(W) + '┘'))
  console.log()
}
